import owd from 'owd/owd';

export default class Arrow extends owd.Component {
	init() {
		this.bind();
	}

	bind() {

		this.on('load ajaxload', this.dom.$window, () => {

			let morphTl = anime.timeline({
				loop: true,
				elasticity: 0
			});

			morphTl
				.add({
					targets: '#arrow',
					translateY: [
						{ value: 1, duration: 800 },
						{ value: -2, duration: 500 },
						{ value: 1, duration: 800 },
						{ value: -1, duration: 500 }
					],
					offset: 0
				})
				.add({
					targets: '#arrow-left',
					translateX: [
						{ value: 1, duration: 800 },
						{ value: -2, duration: 500 },
						{ value: 1, duration: 800 },
						{ value: -1, duration: 500 }
					],
					offset: 0
				});
		});

	}

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('arrow', {
	component: Arrow
});
